import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _filter from 'lodash/filter';
import _get from 'lodash/get';
import _reduce from 'lodash/reduce';
import _includes from 'lodash/includes';
import _isEmpty from 'lodash/isEmpty';
import _find from 'lodash/find';
import _size from 'lodash/size';
import _toNumber from 'lodash/toNumber';
import _compact from 'lodash/compact';
import _every from 'lodash/every';
import _upperFirst from 'lodash/upperFirst';
import _map from 'lodash/map';
import _join from 'lodash/join';
import _values from 'lodash/values';
import _pick from 'lodash/pick';
import _toLower from 'lodash/toLower';
import _some from 'lodash/some';
import _set from 'lodash/set';
import _isNil from 'lodash/isNil';
import _startCase from 'lodash/startCase';
import { EMPTY_OBJECT, EMPTY_STRING, EMPTY_ARRAY } from '../app.constants';
import { RECALL_STATUS, JOB_STATUS } from '../constants/repairOrder/constants';
import { STATUS } from '../constants/status.constants';
import { INVALID_VIN_CHARS } from '../constants/vehicleInventory/vehicle';
import { VEHICLE_STATUS } from '../constants/vehicleInventory/vehicleStatus';
import { DISPLAY_MODEL_KEY_VS_VALUE, DISPLAY_MODEL } from '../constants/retail/salesSetup.constants';
import { formatCurrency } from '../formatters/formatCurrency';
import { getDifferenceAsDays, toMoment, getCurrentTime } from '../utils/dateUtils';
import moneyUtils from '../utils/money';
import { tget } from '../utils/general';
import VehicleReader from '../readers/Vehicle';
var PAY_TYPE_VALUES = {
  CUSTOMER_PAY: 'CUSTOMER_PAY',
  WARRANTY: 'WARRANTY',
  INTERNAL: 'INTERNAL'
};
export var getFormattedMake = function getFormattedMake(make) {
  return make.toString().split('-').map(function (str) {
    return _startCase(str);
  }).join('-');
};
export function getVehicleAgeInDays(vehicle, config) {
  var _ref = vehicle || {},
      vehicleSoldTime = _ref.vehicleSoldTime;

  var field = tget(config, 'field', 'entryTime');

  var date = _get(vehicle, field);

  if (!date || date < 0) return null;
  return vehicleSoldTime ? getDifferenceAsDays(toMoment(vehicleSoldTime), toMoment(date)) : getDifferenceAsDays(getCurrentTime(), toMoment(date));
}
export var getYearMakeModel = function getYearMakeModel(vehicle) {
  if (_isEmpty(vehicle)) return EMPTY_STRING;
  var year = vehicle.year,
      make = vehicle.make;
  var model = getDisplayModalText(vehicle);

  var ymmGrouped = _compact([year, make, model]);

  return _join(_map(ymmGrouped, function (item) {
    return getFormattedMake(item);
  }), ' ');
};
export var isValidJob = function isValidJob(status) {
  return !_includes([STATUS.VOIDED, STATUS.CANCELLED], status);
};

var hasValidCostCenter = function hasValidCostCenter(operations) {
  return _every(operations, function (operation) {
    return !_isEmpty(_get(operation, 'costCenters'));
  });
};
/**
 * OpenRO Price should only be sum of INTERNAL_PAY jobs
 * with operations which have a costCenter
 * @param {*} data
 */


export var getOpenROPrice = function getOpenROPrice(data) {
  var _ref2 = data || EMPTY_OBJECT,
      jobs = _ref2.jobs;

  var totalInternalPrice = _reduce(_filter(jobs, function (_ref3) {
    var payType = _ref3.payType,
        status = _ref3.status,
        operations = _ref3.operations;
    return hasValidCostCenter(operations) && payType === PAY_TYPE_VALUES.INTERNAL && isValidJob(status);
  }), function (total, _ref4) {
    var id = _ref4.id;
    var jobTotal = _get(data[id], 'amount') || 0;
    return total + jobTotal;
  }, 0);

  return formatCurrency(moneyUtils.withPrecision(totalInternalPrice));
};
export var getOpenRecall = function getOpenRecall() {
  var vehicle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var roDetails = vehicle.roDetails,
      recallDetails = vehicle.recallDetails;

  var recallJobs = _reduce(roDetails, function (recalls, _ref5) {
    var recallJobDetails = _ref5.recallJobDetails;
    return [].concat(_toConsumableArray(recalls), _toConsumableArray(recallJobDetails || EMPTY_ARRAY));
  }, []);

  return _filter(recallDetails, function (recall) {
    var recallWithRO = _find(recallJobs, function (_ref6) {
      var jobStatus = _ref6.jobStatus,
          recallNumber = _ref6.recallNumber;
      return jobStatus !== JOB_STATUS.VOID && recallNumber === _get(recall, 'manufacturerRecallNumber');
    });

    return _isEmpty(recallWithRO) && _get(recall, 'manufacturerRecallNumber') && _get(recall, 'manufacturerRecallStatus') !== RECALL_STATUS.CLOSED;
  });
};
export var getOpenRO = function getOpenRO(vehicle) {
  var roDetails = tget(vehicle, 'roDetails', EMPTY_ARRAY);
  return _filter(roDetails, function (ro) {
    return !_includes([STATUS.VOIDED, STATUS.CLOSED], ro.roStatus);
  });
};
export var hasPendingRO = function hasPendingRO(vehicle) {
  var openRoDetails = getOpenRO(vehicle);
  var openRecallDetails = getOpenRecall(vehicle) || EMPTY_ARRAY; // const hasOpenPDI = _get(vehicle, 'pdiDetail.applicable') && !isPDIDone(vehicle);

  return _size([].concat(_toConsumableArray(openRoDetails), _toConsumableArray(openRecallDetails))) > 0;
};
export var getOpenInternalRos = function getOpenInternalRos(roList) {
  return (roList || []).filter(function (ro) {
    var internalPayStatus = _get(ro, 'invoice.internalPay.status');

    return internalPayStatus !== STATUS.CLOSED;
  });
};
export var getPoPriceForVIN = function getPoPriceForVIN(poList, targetVin) {
  return _toNumber(_reduce(poList, function (totalAmount, _ref7) {
    var subletItemAmount = _ref7.totalAmount,
        vin = _ref7.vin;
    if (vin === targetVin) return moneyUtils.add(totalAmount, subletItemAmount);
    return totalAmount;
  }, 0));
};
export var getVehicleIcon = function getVehicleIcon(vehicle) {
  return _get(vehicle, 'thumbnailIcon.url') ? _get(vehicle, 'thumbnailIcon.url', EMPTY_STRING) : _get(vehicle, 'iconDetail.thumbnailUrl', EMPTY_STRING);
};
export var getTrimDisplayValue = function getTrimDisplayValue(vehicleInfo) {
  if (_isEmpty(vehicleInfo)) return '';

  var vehicleDisplayValues = _values(_filter(_pick(vehicleInfo, ['trim', 'engineDescriptionDisplay', 'driveType', 'transmissionControlTypeDisplay', 'bodyType'])), function (trimInfo) {
    return !!trimInfo;
  });

  return _join(vehicleDisplayValues, ': ');
};
var TRIM_DETAILS_KEYS = ['trim', 'driveType', 'aspiration', 'engineDescription', 'engineSize', 'fuelType', 'fuelDeliveryType', 'transmissionControlType', 'bodyType', 'engineCylinders'];
var VIN_LOOKUP_STATUS = {
  SUCCESS: 'SUCCESS',
  PARTIAL: 'PARTIAL'
};

var transformObjectValuesToString = function transformObjectValuesToString(object) {
  return !_isEmpty(object) && Object.keys(object).map(function (value) {
    return object[value] || EMPTY_STRING;
  }).filter(function (value) {
    return value;
  }).join(' | ');
};

export var getRequiredVINDetails = function getRequiredVINDetails() {
  var vinLookupResponse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  if (_isEmpty(vinLookupResponse)) return undefined;

  var trimDetails = _objectSpread(_objectSpread({}, _pick(vinLookupResponse, TRIM_DETAILS_KEYS)), {}, {
    bodyClass: _get(vinLookupResponse, 'marketClassCategory')
  });

  return {
    vin: _get(vinLookupResponse, 'vin'),
    year: _get(vinLookupResponse, 'year'),
    make: _toLower(_get(vinLookupResponse, 'make')),
    model: _get(vinLookupResponse, 'model'),
    trimDetails: trimDetails,
    trim: transformObjectValuesToString(trimDetails),
    bodyClass: _get(vinLookupResponse, 'marketClassCategory'),
    isVinLookUpResloved: _get(vinLookupResponse, 'trimStatus') === VIN_LOOKUP_STATUS.SUCCESS
  };
};
export var hasOpenRO = function hasOpenRO(vehicle) {
  return _size(getOpenRO(vehicle)) > 0;
};
export var checkIfVINContainsInvalidCharacters = function checkIfVINContainsInvalidCharacters(vin) {
  return _some(INVALID_VIN_CHARS, function (_char) {
    return _includes(vin, _char);
  });
};

var getSanitizedVehicleYear = function getSanitizedVehicleYear(year) {
  return !_isNil(year) ? _toNumber(year) : null;
};

export var getSanitizedVehicle = function getSanitizedVehicle(vehicle) {
  return !_isEmpty(vehicle) ? _set(vehicle, 'year', getSanitizedVehicleYear(VehicleReader.year(vehicle))) : EMPTY_OBJECT;
};
export var getSanitizedYearMakeModel = function getSanitizedYearMakeModel(vehicle) {
  var displayModelSource = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DISPLAY_MODEL;
  if (_isEmpty(vehicle)) return EMPTY_STRING;
  var sanitizedModel = tget(vehicle, DISPLAY_MODEL_KEY_VS_VALUE[displayModelSource], VehicleReader.displayModel(vehicle) || VehicleReader.model(vehicle));

  var ymmGrouped = _compact([VehicleReader.year(vehicle), VehicleReader.make(vehicle), sanitizedModel]);

  return _join(_map(ymmGrouped, function (item) {
    return _upperFirst(item);
  }), ' ');
};
export var getDisplayModalText = function getDisplayModalText(vehicle) {
  var displayModelSource = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DISPLAY_MODEL;
  return tget(vehicle, DISPLAY_MODEL_KEY_VS_VALUE[displayModelSource], VehicleReader.displayModel(vehicle) || VehicleReader.model(vehicle));
};
export var getDaysTosell = function getDaysTosell(vehicle) {
  var postDate = VehicleReader.postDate(vehicle);
  var entryTime = VehicleReader.entryTime(vehicle);
  return postDate && entryTime ? getDifferenceAsDays(toMoment(postDate), toMoment(entryTime)) : null;
};
export var getDaysOnLot = function getDaysOnLot(vehicle) {
  var entryTime = VehicleReader.entryTime(vehicle);
  var status = VehicleReader.status(vehicle);
  return status !== VEHICLE_STATUS.SOLD && entryTime ? getDifferenceAsDays(getCurrentTime(), toMoment(entryTime)) : null;
};